/* eslint-disable import/prefer-default-export */
import React from 'react';

import useCDNUrl from '../../../hooks/useCDNUrl.js';

export default function PrivateDataLoading({sourceName, loadingImageUrl}) {
    const loadingImageCdnUrl = useCDNUrl(loadingImageUrl);

    return (
        <div className='tlw-grid tlw-grid-cols-1'>
            <div className='tlw-text-center'>
                <h3>{`We're loading your ${sourceName} data into Rival IQ`}</h3>
                <p>We will send you an email when your data is ready.</p>
            </div>
            <img
                className='tlw-m-auto tlw-items-center'
                alt='loading '
                src={loadingImageCdnUrl}
            />
        </div>
    );
}
